import { IMessage } from "../interfaces/message";
import { axiosApi } from "../../../../../../../api/dbAxios";

export const exportChatConv = async (messages: IMessage[]) => {
  try {
    const response = await axiosApi.post(`/chat/export/`, messages, {
      responseType: "arraybuffer",
    });
    return response.data;
  } catch (error) {
    console.error("Error updating document info:", error);
    throw error;
  }
};
